class MarketNewsDTO {
    constructor(params) {
        this.related = params.related;
        this.currentPrice = params.currentPrice;
        this.industryName = params.industryName;
        this.trending = params.trending;
        this.pubDate = params.pubDate;
        this.pubDateEpoch = params.pubDateEpoch;
        this.title = params.title;
        this.source = params.source;
        this.postType = params.postType;
        this.sectorName = params.sectorName;
        this.sectorId = params.sectorId;
        this.description = params.description;
        this.pdfUrl = params.pdfUrl;
        this.bseCode = params.bseCode;
        this.isin = params.isin;
        this.postId = params.postId;
        this.industryId = params.industryId;
        this.videoUrl = params.videoUrl;
        this.authorName = params.authorName;
        this.authorId = params.authorId;
        this.interestId = params.interestId;
        this.url = params.url;
        this.imageUrl = params.imageUrl;
        this.nseCode = params.nseCode;
        this.customElements = params.customElements;
    }
}
export default MarketNewsDTO;
